/**
 * How the scenery's trees and rocks are drawn (E5.3; a presentation flag, like the fine ground's and the aim's).
 * `instanced`: the person-scale stands in chunks with tiers of detail (rendering/treeStands.ts), the planet-scale
 * rocks merged per planet (rendering/rockMerge.ts). `each`: every tree and rock its own model, the old way —
 * kept for an A/B of the look and the frame rate.
 *
 * Read from `?trees=each` by the game; the Lab sets the override before it launches (it starts the match
 * in-page, with no URL to read).
 */
export type TreeDrawMode = 'instanced' | 'each';
export const TREE_DRAW_MODES: readonly TreeDrawMode[] = ['instanced', 'each'];

let override: TreeDrawMode | null = null;

/** The Lab's launch (null: back to the URL / the default). */
export function setTreeDrawMode(m: TreeDrawMode | null): void { override = m; }

/** The mode in force: the Lab's override, else the page's `?trees=`, else instanced. */
export function treeDrawMode(): TreeDrawMode {
  if (override) return override;
  try { return typeof location !== 'undefined' && new URLSearchParams(location.search).get('trees') === 'each' ? 'each' : 'instanced'; }
  catch { return 'instanced'; }
}
